















































import { Component, Vue } from 'vue-property-decorator';
import { BForm, BFormRow, BCol, BFormGroup, BFormInput, BFormSelect, BButton, BIconSearch, BIconArrowCounterclockwise, BFormSelectOption } from 'bootstrap-vue';
import ProjectFilterOptions from '@/types/ProjectFilterOptions';
import EntityReference from '@/types/EntityReference';
import AxiosService from '@/services/axiosService';
import i18n from '../i18n';

@Component({
    components: {
        'b-form': BForm,
        'b-form-row': BFormRow,
        'b-col': BCol,
        'b-form-group': BFormGroup,
        'b-form-input': BFormInput,
        'b-form-select': BFormSelect,
        'b-form-select-option': BFormSelectOption,
        'b-btn': BButton,
        'b-icon-search': BIconSearch,
        'b-icon-arrow-counterclockwise': BIconArrowCounterclockwise
    }
})
export default class ProjectFilter extends Vue {
    clients: EntityReference[] = [];
    projectManagers: EntityReference[] = [];
    apiAccessToken = this.$store.state.apiAccessToken;

    projectStatuses: ProjectStatus[] = [
        { value: null, text: 'projectStatus.selectProjectStatus' },
        { value: true, text: 'projectStatus.yes' },
        { value: false, text: 'projectStatus.no' }
    ]

    filter: ProjectFilterOptions = {
        sequenceOrName: null,
        isActive: true,
        clientId: null,
        projectManagerId: null
    }

    mounted() {
        this.apiAccessToken = this.$store.state.apiAccessToken;
        this.loadClients();
        this.loadProjectManagers();
    }

    filterList(resetFilter: boolean) {
        if (resetFilter) {
            this.filter.sequenceOrName = null;
            this.filter.isActive = true;
            this.filter.clientId = null;
            this.filter.projectManagerId = null;
        }
        this.$emit('filter-list', this.filter);
    }

    async loadClients() {
        try {
            const response = await AxiosService.request<EntityList>({
                url: `clientslookup`,
                method: 'GET'
            });

            this.clients = response.data.records ?? [];
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }

    async loadProjectManagers() {
        try {
            const response = await AxiosService.request<EntityList>({
                url: `projectslookup/projectmanagers`,
                method: 'GET'
            });

            this.projectManagers = response.data.records ?? [];
        }
        catch (error) {
            if (error.response) {
                switch (error.response.status) {
                    case 404:
                        return this.$router.push(`/${i18n.locale}/notfound`);
                    case 403:
                        return this.$router.push(`/${i18n.locale}/accessdenied`);
                    default:
                        return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                }
            }
        }
    }
}    

interface ProjectStatus {
    value: boolean | null;
    text: string;
}

 interface EntityList {
    records: EntityReference[];
}
